import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { uniqueId, defer } from 'lodash';
import Checkbox from 'chameleon/ui-stack/ui/base/checkbox';
import { v4 as uuidv4 } from 'uuid';

const CheckboxField = (props) => {
  const { control } = useFormContext();
  const {
    name,
    title,
    description,
    rules,
    onValueChange = () => {},
    accessibility,
  } = props;

  const inputId = uniqueId(name);
  const componentUuid = `checkbox-${uuidv4()}`;

  return (
    <div className="d-block mb-8" data-test-id={props['data-test-id']}>
      <div className="h-8 d-flex flex-row items-center mb-0.8 text-gray-800">
        <Controller
          control={control}
          id={inputId}
          name={name}
          rules={rules}
          render={({ field }) => (
            <Checkbox
              description={description}
              checked={field.value}
              onClick={(checked) =>
                defer(() => {
                  field.onChange(checked);
                  onValueChange(checked);
                })
              }
              accessibility={{
                ...accessibility,
                'aria-labelledby': componentUuid,
              }}
              name={name}
              disabled={field.disabled}
            />
          )}
        />
        <label id={componentUuid} className="mx-2 text-base" htmlFor={inputId}>
          {title}
        </label>
      </div>
      {props.children && <div className="mt-4 px-2">{props.children}</div>}
    </div>
  );
};

export default CheckboxField;
